{
  "three-acts": {
    "name": "三幕構成",
    "summary": "設定、対立、解決。多くの小説や映画に共通する構成です。",
    "bestFor": "ジャンルを問わず、シンプルな初稿を書きたいときに。",
    "metaTitle": "三幕構成の物語テンプレート — Musael",
    "metaDescription": "設定、対立、解決。多くの小説や映画に共通する三幕構成。ジャンルを問わず、シンプルな初稿を書きたいときに使えます。",
    "acts": [
      {
        "title": "第I幕：設定",
        "synopsis": "主人公は誰で、何を望んでいるのか。そして日常を終わらせる出来事。",
        "chapters": [
          {
            "title": "日常の世界",
            "synopsis": "慣れた環境にいる主人公。物語で試される願望と弱点を示します。",
            "scenes": [
              {
                "title": "冒頭のイメージ",
                "synopsis": "何かが変わる前の主人公を切り取ります。"
              },
              {
                "title": "物語のフック",
                "synopsis": "ささいだけれど奇妙な、波乱を予感させる出来事。"
              }
            ]
          },
          {
            "title": "発端となる事件",
            "synopsis": "主人公が無視できない出来事。",
            "scenes": [
              {
                "title": "きっかけの事件",
                "synopsis": "問題が起こり、そのままでは去ってくれません。"
              },
              {
                "title": "迷い",
                "synopsis": "主人公がためらい、何を失うおそれがあるのかが見えてきます。"
              }
            ]
          },
          {
            "title": "境界を越える",
            "synopsis": "主人公が覚悟を決めます。もう簡単には戻れません。",
            "scenes": [
              {
                "title": "決断",
                "synopsis": "主人公は行動を選び、慣れ親しんだものを後にします。"
              }
            ]
          }
        ]
      },
      {
        "title": "第II幕：対立",
        "synopsis": "主人公は挑戦し、失敗し、学びます。その間にも、失うものは大きくなります。",
        "chapters": [
          {
            "title": "高まる代償",
            "synopsis": "新しいルール、味方、敵。最初の勝利にも代償があります。",
            "scenes": [
              {
                "title": "最初の試練",
                "synopsis": "主人公は新しい世界に出会い、その一部を誤解します。"
              },
              {
                "title": "味方と敵",
                "synopsis": "誰が助け、誰が妨げるのか。その理由も描きます。"
              }
            ]
          },
          {
            "title": "物語の中間点",
            "synopsis": "物語の意味を変える逆転。",
            "scenes": [
              {
                "title": "中間点",
                "synopsis": "見せかけの勝利か敗北。主人公は受け身をやめ、自ら動き始めます。"
              }
            ]
          },
          {
            "title": "すべてが崩れる",
            "synopsis": "敵が迫り、主人公の弱点が大きな代償をもたらします。",
            "scenes": [
              {
                "title": "追い詰められる",
                "synopsis": "どの計画も抵抗に遭い、人間関係に亀裂が入ります。"
              },
              {
                "title": "すべてを失う",
                "synopsis": "どん底の瞬間。目標は二度と手が届かないように思えます。"
              }
            ]
          }
        ]
      },
      {
        "title": "第III幕：解決",
        "synopsis": "主人公は変化し、最後の試練に向き合い、新しい日常が始まります。",
        "chapters": [
          {
            "title": "物語の頂点",
            "synopsis": "第II幕で得た学びによって勝利する、最後の対決。",
            "scenes": [
              {
                "title": "最後の計画",
                "synopsis": "主人公は学んだことを結集し、最後の挑戦をします。"
              },
              {
                "title": "クライマックス",
                "synopsis": "決着をつける対決。"
              }
            ]
          },
          {
            "title": "新しい日常",
            "synopsis": "主人公と世界に、どのような変化があったのか。",
            "scenes": [
              {
                "title": "結びのイメージ",
                "synopsis": "冒頭を映す鏡となり、主人公がどれほど遠くまで来たかを示します。"
              }
            ]
          }
        ]
      }
    ]
  },
  "heros-journey": {
    "name": "英雄の旅",
    "summary": "冒険への誘いから帰還までの十二段階を、出発、試練、帰還にまとめた構成です。",
    "bestFor": "ファンタジー、冒険、探索の物語に。",
    "metaTitle": "英雄の旅の物語テンプレート — Musael",
    "metaDescription": "冒険への誘いから帰還までの十二段階を、出発、試練、帰還に整理。ファンタジー、冒険、探索の物語に使えるテンプレートです。",
    "acts": [
      {
        "title": "出発",
        "synopsis": "主人公は知っている世界を離れます。",
        "chapters": [
          {
            "title": "日常の世界",
            "synopsis": "冒険前の主人公。家、習慣、そして足りないもの。",
            "scenes": [
              {
                "title": "日常の世界",
                "synopsis": "冒険前の主人公。家、習慣、そして足りないもの。"
              }
            ]
          },
          {
            "title": "冒険への誘い",
            "synopsis": "挑戦や知らせが、日常の世界を揺さぶります。",
            "scenes": [
              {
                "title": "冒険への誘い",
                "synopsis": "挑戦や知らせが、日常の世界を揺さぶります。"
              }
            ]
          },
          {
            "title": "誘いの拒絶",
            "synopsis": "恐れや義務が主人公を引き止めます。",
            "scenes": [
              {
                "title": "誘いの拒絶",
                "synopsis": "恐れや義務が主人公を引き止めます。"
              }
            ]
          },
          {
            "title": "導き手との出会い",
            "synopsis": "誰かが助言、訓練、あるいは贈り物を与えます。",
            "scenes": [
              {
                "title": "導き手との出会い",
                "synopsis": "誰かが助言、訓練、あるいは贈り物を与えます。"
              }
            ]
          },
          {
            "title": "最初の境界を越える",
            "synopsis": "主人公は非日常の世界へ入ります。",
            "scenes": [
              {
                "title": "最初の境界を越える",
                "synopsis": "主人公は非日常の世界へ入ります。"
              }
            ]
          }
        ]
      },
      {
        "title": "試練",
        "synopsis": "非日常の世界での試練、そして最大の難関。",
        "chapters": [
          {
            "title": "試練、味方、敵",
            "synopsis": "主人公は新しい世界のルールを学びます。",
            "scenes": [
              {
                "title": "試練、味方、敵",
                "synopsis": "主人公は新しい世界のルールを学びます。"
              }
            ]
          },
          {
            "title": "最も深い洞窟への接近",
            "synopsis": "中心となる危険に向けた準備。",
            "scenes": [
              {
                "title": "最も深い洞窟への接近",
                "synopsis": "中心となる危険に向けた準備。"
              }
            ]
          },
          {
            "title": "最大の試練",
            "synopsis": "生死を分ける危機。主人公の中の何かが死にます。",
            "scenes": [
              {
                "title": "最大の試練",
                "synopsis": "生死を分ける危機。主人公の中の何かが死にます。"
              }
            ]
          },
          {
            "title": "報酬",
            "synopsis": "主人公は宝、知識、あるいは和解を手にします。",
            "scenes": [
              {
                "title": "報酬",
                "synopsis": "主人公は宝、知識、あるいは和解を手にします。"
              }
            ]
          }
        ]
      },
      {
        "title": "帰還",
        "synopsis": "家へ向かう道、最後の試練、そして主人公が持ち帰るもの。",
        "chapters": [
          {
            "title": "帰路",
            "synopsis": "主人公は帰路につきます。追われることもよくあります。",
            "scenes": [
              {
                "title": "帰路",
                "synopsis": "主人公は帰路につきます。追われることもよくあります。"
              }
            ]
          },
          {
            "title": "復活",
            "synopsis": "学んだすべてを使う、最後の試練。",
            "scenes": [
              {
                "title": "復活",
                "synopsis": "学んだすべてを使う、最後の試練。"
              }
            ]
          },
          {
            "title": "宝を携えた帰還",
            "synopsis": "主人公は変わって帰ってきます。分かち合うものを携えて。",
            "scenes": [
              {
                "title": "宝を携えた帰還",
                "synopsis": "主人公は変わって帰ってきます。分かち合うものを携えて。"
              }
            ]
          }
        ]
      }
    ]
  },
  "fifteen-beats": {
    "name": "十五のビートによる構成",
    "summary": "脚本家が使うビートシート。三幕に十五の転換点を配置します。",
    "bestFor": "明確な転換点を持つ、引き締まった商業的な筋書きに。",
    "metaTitle": "十五のビートの物語テンプレート — Musael",
    "metaDescription": "脚本家が使うビートシート。三幕に十五の転換点を配置。明確な転換点を持つ、引き締まった商業的な筋書きに向いています。",
    "acts": [
      {
        "title": "第I幕",
        "synopsis": "これまでの世界と、そこを離れる選択。",
        "chapters": [
          {
            "title": "冒頭のイメージ",
            "synopsis": "物語が始まる前の主人公と世界。",
            "scenes": [
              {
                "title": "冒頭のイメージ",
                "synopsis": "物語が始まる前の主人公と世界。"
              }
            ]
          },
          {
            "title": "テーマの提示",
            "synopsis": "誰かが物語の本当のテーマを口にします。主人公はまだ気づきません。",
            "scenes": [
              {
                "title": "テーマの提示",
                "synopsis": "誰かが物語の本当のテーマを口にします。主人公はまだ気づきません。"
              }
            ]
          },
          {
            "title": "設定",
            "synopsis": "主人公の生活、周囲の人々、そして修正すべきこと。",
            "scenes": [
              {
                "title": "設定",
                "synopsis": "主人公の生活、周囲の人々、そして修正すべきこと。"
              }
            ]
          },
          {
            "title": "きっかけ",
            "synopsis": "物語を動かし始める出来事。",
            "scenes": [
              {
                "title": "きっかけ",
                "synopsis": "物語を動かし始める出来事。"
              }
            ]
          },
          {
            "title": "迷い",
            "synopsis": "主人公は何をすべきか迷います。",
            "scenes": [
              {
                "title": "迷い",
                "synopsis": "主人公は何をすべきか迷います。"
              }
            ]
          },
          {
            "title": "第二幕への移行",
            "synopsis": "主人公は新しい道を選びます。",
            "scenes": [
              {
                "title": "第二幕への移行",
                "synopsis": "主人公は新しい道を選びます。"
              }
            ]
          }
        ]
      },
      {
        "title": "第II幕",
        "synopsis": "設定から期待される展開、そして転落。",
        "chapters": [
          {
            "title": "副筋",
            "synopsis": "テーマを担う第二の物語。多くの場合、人間関係を描きます。",
            "scenes": [
              {
                "title": "副筋",
                "synopsis": "テーマを担う第二の物語。多くの場合、人間関係を描きます。"
              }
            ]
          },
          {
            "title": "楽しみと遊び",
            "synopsis": "設定の約束が果たされます。読者が求めていた展開です。",
            "scenes": [
              {
                "title": "楽しみと遊び",
                "synopsis": "設定の約束が果たされます。読者が求めていた展開です。"
              }
            ]
          },
          {
            "title": "中間点",
            "synopsis": "見せかけの勝利や敗北によって、賭けるものが大きくなります。",
            "scenes": [
              {
                "title": "中間点",
                "synopsis": "見せかけの勝利や敗北によって、賭けるものが大きくなります。"
              }
            ]
          },
          {
            "title": "敵が迫る",
            "synopsis": "内からは疑い、外からは圧力。",
            "scenes": [
              {
                "title": "敵が迫る",
                "synopsis": "内からは疑い、外からは圧力。"
              }
            ]
          },
          {
            "title": "すべてを失う",
            "synopsis": "中間点とは反対の状態。最も深いどん底。",
            "scenes": [
              {
                "title": "すべてを失う",
                "synopsis": "中間点とは反対の状態。最も深いどん底。"
              }
            ]
          },
          {
            "title": "魂の暗夜",
            "synopsis": "主人公は失ったものを悼み、そこから学びを見いだします。",
            "scenes": [
              {
                "title": "魂の暗夜",
                "synopsis": "主人公は失ったものを悼み、そこから学びを見いだします。"
              }
            ]
          }
        ]
      },
      {
        "title": "第III幕",
        "synopsis": "学びを実践します。",
        "chapters": [
          {
            "title": "第三幕への移行",
            "synopsis": "副筋から生まれた新しい考えが、道を開きます。",
            "scenes": [
              {
                "title": "第三幕への移行",
                "synopsis": "副筋から生まれた新しい考えが、道を開きます。"
              }
            ]
          },
          {
            "title": "フィナーレ",
            "synopsis": "主人公は壊れたものを修復し、後戻りできないほど変わります。",
            "scenes": [
              {
                "title": "フィナーレ",
                "synopsis": "主人公は壊れたものを修復し、後戻りできないほど変わります。"
              }
            ]
          },
          {
            "title": "最後のイメージ",
            "synopsis": "物語の後の世界。冒頭のイメージを映し返します。",
            "scenes": [
              {
                "title": "最後のイメージ",
                "synopsis": "物語の後の世界。冒頭のイメージを映し返します。"
              }
            ]
          }
        ]
      }
    ]
  },
  "seven-point": {
    "name": "七つのポイントによる構成",
    "summary": "結末から逆算します。フック、転換、圧力、中間点、そして解決。",
    "bestFor": "結末を先に思い描く作家に。",
    "metaTitle": "七つのポイントの物語テンプレート — Musael",
    "metaDescription": "結末から逆算する構成。フック、転換、圧力、中間点、解決を組み立てます。結末を先に思い描く作家に向いています。",
    "acts": [
      {
        "title": "",
        "synopsis": "",
        "chapters": [
          {
            "title": "フック",
            "synopsis": "出発点の状態。解決時とは反対です。",
            "scenes": [
              {
                "title": "フック",
                "synopsis": "出発点の状態。解決時とは反対です。"
              }
            ]
          },
          {
            "title": "転換点1",
            "synopsis": "対立が始まり、主人公は行動へ押し出されます。",
            "scenes": [
              {
                "title": "転換点1",
                "synopsis": "対立が始まり、主人公は行動へ押し出されます。"
              }
            ]
          },
          {
            "title": "圧力点1",
            "synopsis": "敵対者が圧力をかけ、主人公は動かざるを得なくなります。",
            "scenes": [
              {
                "title": "圧力点1",
                "synopsis": "敵対者が圧力をかけ、主人公は動かざるを得なくなります。"
              }
            ]
          },
          {
            "title": "中間点",
            "synopsis": "主人公は反応する立場から、自ら行動する立場へ移ります。",
            "scenes": [
              {
                "title": "中間点",
                "synopsis": "主人公は反応する立場から、自ら行動する立場へ移ります。"
              }
            ]
          },
          {
            "title": "圧力点2",
            "synopsis": "事態は大きく悪化し、計画は失敗します。",
            "scenes": [
              {
                "title": "圧力点2",
                "synopsis": "事態は大きく悪化し、計画は失敗します。"
              }
            ]
          },
          {
            "title": "転換点2",
            "synopsis": "主人公は勝利に必要な最後の要素を手にします。",
            "scenes": [
              {
                "title": "転換点2",
                "synopsis": "主人公は勝利に必要な最後の要素を手にします。"
              }
            ]
          },
          {
            "title": "解決",
            "synopsis": "結末の状態。フックへの答えです。",
            "scenes": [
              {
                "title": "解決",
                "synopsis": "結末の状態。フックへの答えです。"
              }
            ]
          }
        ]
      }
    ]
  },
  "kishotenketsu": {
    "name": "起承転結",
    "summary": "対立ではなく、転換を軸に組み立てる四つの流れ。",
    "bestFor": "文芸小説、短編、登場人物を軸にした静かな物語に。",
    "metaTitle": "起承転結の物語テンプレート — Musael",
    "metaDescription": "対立ではなく転換を軸にした四つの流れ。文芸小説、短編、登場人物を軸にした静かな物語に向いています。",
    "acts": [
      {
        "title": "",
        "synopsis": "",
        "chapters": [
          {
            "title": "起：導入",
            "synopsis": "登場人物とその世界を、穏やかに描きます。",
            "scenes": [
              {
                "title": "導入",
                "synopsis": "誰が、どこにいて、日常がどう見えるのか。"
              }
            ]
          },
          {
            "title": "承：展開",
            "synopsis": "状況が深まります。まだ転換は起こりません。",
            "scenes": [
              {
                "title": "展開",
                "synopsis": "登場人物への理解が深まり、小さな変化が生まれます。"
              }
            ]
          },
          {
            "title": "転：転換",
            "synopsis": "予想外の要素が、すべての見え方を変えます。",
            "scenes": [
              {
                "title": "転換",
                "synopsis": "一見関係のなさそうな、新しい何かが現れます。"
              }
            ]
          },
          {
            "title": "結：結び",
            "synopsis": "各部分がつながり、新たな理解が生まれます。",
            "scenes": [
              {
                "title": "結び",
                "synopsis": "転換と物語が交わり、意味が変化します。"
              }
            ]
          }
        ]
      }
    ]
  },
  "mystery": {
    "name": "ミステリー",
    "summary": "犯罪、手がかりと偽の手がかりを追う捜査、そして読者に公正な真相の提示。",
    "bestFor": "犯罪小説、探偵小説、コージーミステリーに。",
    "metaTitle": "ミステリーの物語テンプレート — Musael",
    "metaDescription": "犯罪、手がかり、偽の手がかりを追う捜査と、公正な真相の提示。犯罪小説、探偵小説、コージーミステリー向けです。",
    "acts": [
      {
        "title": "犯罪",
        "synopsis": "何かがおかしい。誰かが理由を突き止めなければなりません。",
        "chapters": [
          {
            "title": "発見",
            "synopsis": "犯罪、あるいは失踪。",
            "scenes": [
              {
                "title": "遺体",
                "synopsis": "犯罪が発覚します。最初の印象と最初の疑問。"
              },
              {
                "title": "探偵",
                "synopsis": "誰が捜査するのか。なぜその人にとって重要なのか。"
              }
            ]
          }
        ]
      },
      {
        "title": "捜査",
        "synopsis": "手がかり、容疑者、偽の手がかり。",
        "chapters": [
          {
            "title": "容疑者",
            "synopsis": "動機とアリバイを持つ人々。",
            "scenes": [
              {
                "title": "聞き取り",
                "synopsis": "どの容疑者にも、嘘をつく理由があります。"
              },
              {
                "title": "最初の手がかり",
                "synopsis": "後で重要になる事実。読者に対して公正に提示します。"
              }
            ]
          },
          {
            "title": "偽の手がかり",
            "synopsis": "捜査は間違った方向へ進みます。",
            "scenes": [
              {
                "title": "ミスリード",
                "synopsis": "証拠は犯人ではない人物を指します。"
              },
              {
                "title": "事態の激化",
                "synopsis": "第二の犯罪や脅迫によって、賭けるものが大きくなります。"
              }
            ]
          },
          {
            "title": "隠された真実",
            "synopsis": "探偵は、最初からそこにあったものに気づきます。",
            "scenes": [
              {
                "title": "欠けていた要素",
                "synopsis": "小さな細部が、それまでの手がかりを結びつけます。"
              }
            ]
          }
        ]
      },
      {
        "title": "真相の提示",
        "synopsis": "解決と、その代償。",
        "chapters": [
          {
            "title": "事件の解決",
            "synopsis": "すべての手がかりが説明されます。",
            "scenes": [
              {
                "title": "真相の提示",
                "synopsis": "犯人が明かされ、推理の筋道が示されます。"
              },
              {
                "title": "事件の後",
                "synopsis": "正義、あるいはその不在。そして探偵の中に残るもの。"
              }
            ]
          }
        ]
      }
    ]
  },
  "romance": {
    "name": "ロマンス",
    "summary": "二人の人物、二人を隔てるもの、そして互いを選ぶために必要なこと。",
    "bestFor": "どんな舞台のロマンスや恋愛物語にも。",
    "metaTitle": "ロマンスの物語テンプレート — Musael",
    "metaDescription": "二人の人物、二人を隔てるもの、互いを選ぶために必要なこと。どんな舞台のロマンスや恋愛物語にも使えます。",
    "acts": [
      {
        "title": "恋に落ちる",
        "synopsis": "二人は出会い、抵抗し、恋に落ち始めます。",
        "chapters": [
          {
            "title": "出会い",
            "synopsis": "最初の出会い。ときめきと障害。",
            "scenes": [
              {
                "title": "対面",
                "synopsis": "二人の主人公が出会います。相手の何かが心に深く入り込みます。"
              },
              {
                "title": "抵抗",
                "synopsis": "うまくいかない理由。目標、傷、あるいは状況。"
              }
            ]
          },
          {
            "title": "距離が縮まる",
            "synopsis": "一緒にいざるを得なくなり、互いの本当の姿を知ります。",
            "scenes": [
              {
                "title": "偶然の同行",
                "synopsis": "ある状況が二人を近くにとどめます。"
              },
              {
                "title": "最初の本物の瞬間",
                "synopsis": "相手の本当の姿が垣間見えます。"
              }
            ]
          }
        ]
      },
      {
        "title": "疑い",
        "synopsis": "心を決めた後、それを壊す恐れが生まれます。",
        "chapters": [
          {
            "title": "物語の中間点",
            "synopsis": "二人は自分の気持ちを受け入れます。",
            "scenes": [
              {
                "title": "心を決める",
                "synopsis": "キス、告白、あるいは約束。"
              }
            ]
          },
          {
            "title": "亀裂",
            "synopsis": "古い傷や外からの障害が、ひとまず勝ります。",
            "scenes": [
              {
                "title": "迷い",
                "synopsis": "昔の恐れが戻ってきます。"
              },
              {
                "title": "別離",
                "synopsis": "二人は別れます。それぞれ自分が正しいと信じて。"
              }
            ]
          }
        ]
      },
      {
        "title": "選ぶ",
        "synopsis": "成長、大きな意思表示、そして共に歩む未来。",
        "chapters": [
          {
            "title": "共に",
            "synopsis": "互いにふさわしい存在になれるほど、二人は変わります。",
            "scenes": [
              {
                "title": "大きな意思表示",
                "synopsis": "どちらかがすべてを懸け、自分が変わったことを示します。"
              },
              {
                "title": "いつまでも幸せに",
                "synopsis": "あるいは、今は幸せに。二人が選ぶ未来です。"
              }
            ]
          }
        ]
      }
    ]
  }
}
